var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bank-information" }, [
    _c("fieldset", { staticClass: "info-group" }, [
      _c("legend", [_vm._v(_vm._s(_vm.$t("kyc.section.bankInformation")))]),
    ]),
    _c(
      "fieldset",
      { attrs: { disabled: _vm.kycStatus === "submitted" ? true : false } },
      [
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("bankName"),
                valid: _vm.isFormFieldValid("bankName"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.bankName,
                      expression: "bankInformation.bankName",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "bankNameInput",
                    name: "bankName",
                    "data-vv-as": "Bank Name",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.bankName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "bankName",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "bankName" } },
                  [_vm._v("Bank Name：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("bankName"),
                        expression: "errors.has('bankName')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("bankName")))]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("accountName"),
                valid: _vm.isFormFieldValid("accountName"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.accountName,
                      expression: "bankInformation.accountName",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "accountNameInput",
                    name: "accountName",
                    "data-vv-as": "Account Name",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.accountName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "accountName",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "accountName" },
                  },
                  [_vm._v("Account Name：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("accountName"),
                        expression: "errors.has('accountName')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("accountName")))]
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("accountNumber"),
                valid: _vm.isFormFieldValid("accountNumber"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.accountNumber,
                      expression: "bankInformation.accountNumber",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "accountNumberInput",
                    name: "accountNumber",
                    "data-vv-as": "Beneficiary Number",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.accountNumber },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "accountNumber",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "accountNumber" },
                  },
                  [_vm._v("Beneficiary Number：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("accountNumber"),
                        expression: "errors.has('accountNumber')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("accountNumber")))]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("bankAddress"),
                valid: _vm.isFormFieldValid("bankAddress"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.bankAddress,
                      expression: "bankInformation.bankAddress",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "bankAddressInput",
                    name: "bankAddress",
                    "data-vv-as": "Bank Address",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.bankAddress },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "bankAddress",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "bankAddress" },
                  },
                  [_vm._v("Bank Address：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("bankAddress"),
                        expression: "errors.has('bankAddress')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("bankAddress")))]
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("swift"),
                valid: _vm.isFormFieldValid("swift"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.swift,
                      expression: "bankInformation.swift",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "swiftInput",
                    name: "swift",
                    "data-vv-as": "SWIFT",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.swift },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "swift",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "swift" } },
                  [_vm._v("SWIFT：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("swift"),
                        expression: "errors.has('swift')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("swift")))]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("iban"),
                valid: _vm.isFormFieldValid("iban"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.iban,
                      expression: "bankInformation.iban",
                    },
                  ],
                  attrs: {
                    id: "ibanInput",
                    name: "iban",
                    "data-vv-as": "IBAN",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.iban },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.bankInformation, "iban", $event.target.value)
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "iban" } },
                  [_vm._v("IBAN(Mandatory for European Countries)：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("iban"),
                        expression: "errors.has('iban')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("iban")))]
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("bsbNumber"),
                valid: _vm.isFormFieldValid("bsbNumber"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.bsbNumber,
                      expression: "bankInformation.bsbNumber",
                    },
                  ],
                  attrs: {
                    id: "bsbNumberInput",
                    name: "bsbNumber",
                    "data-vv-as": "bsbNumber",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.bsbNumber },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.bankInformation,
                        "bsbNumber",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "bsbNumber" } },
                  [_vm._v("BSB Number(Mandatory for Australia)：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("bsbNumber"),
                        expression: "errors.has('bsbNumber')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("bsbNumber")))]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.errors.has("aba"),
                valid: _vm.isFormFieldValid("aba"),
              },
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankInformation.aba,
                      expression: "bankInformation.aba",
                    },
                  ],
                  attrs: {
                    id: "abaInput",
                    name: "aba",
                    "data-vv-as": "aba",
                    autocomplete: "off",
                    required: "",
                  },
                  domProps: { value: _vm.bankInformation.aba },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.bankInformation, "aba", $event.target.value)
                    },
                  },
                }),
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                }),
                _c("i", {
                  staticClass: "fa fa-check valid-icon icon-right input-icon",
                }),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "aba" } },
                  [_vm._v("ABA(Routing Number, Mandatory for U.S.)：")]
                ),
                _c("i", { staticClass: "bar" }),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("aba"),
                        expression: "errors.has('aba')",
                      },
                    ],
                    staticClass: "help text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("aba")))]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }